<template>
  <div>
    <el-select
      @change="handleChange"
      v-model="currentTemplateIndex"
      placeholder="请选择封面模板"
    >
      <el-option
        v-for="(item, index) in list"
        :key="index"
        :label="item.name"
        :value="index"
      >
      </el-option>
    </el-select>
    <div class="pr mt20 flex ai_c jc_c" id="capture1">
      <img class="cover_img" :src="list[currentTemplateIndex].imgSrc" alt="" />
      <div class="content_text">
        <div class="title" :style="{ color: list[currentTemplateIndex].color }">
          {{ title_text }}
        </div>
        <template v-if="sub_title_text">
          <img
            class="line_img"
            :src="list[currentTemplateIndex].borderImg"
            alt=""
          />
          <div
            class="sub_title"
            :style="{ color: list[currentTemplateIndex].color }"
          >
            {{ sub_title_text }}
          </div>
          <img
            class="line_img"
            style="margin-top: 3px"
            :src="list[currentTemplateIndex].borderImg"
            alt=""
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    sub_title: {
      type: String,
      default: "",
    },
    list: {
      type: Array,
      default: Array,
    },
  },
  watch: {
    title(e) {
      this.title_text = e;
    },
    sub_title(e) {
      this.sub_title_text = e;
    },
  },
  data() {
    return {
      title_text: "",
      sub_title_text: "",
      currentTemplateType: 1,
      currentTemplateIndex: 0,
    };
  },
  mounted() {
    this.title_text = this.title;
    this.sub_title_text = this.sub_title;
  },
  methods: {
    handleChange(index) {
      console.log("index", index);
      this.currentTemplateIndex = index;
      this.currentTemplateType = this.list[index].type;
    },
  },
};
</script>

<style scoped>
.cover_img {
  width: 230px;
  display: block;
}

.content_text {
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 87px 20px 10px;
  box-sizing: border-box;
}

.title {
  width: 100%;
  text-align: center;
  font-weight: bold;
  font-size: 28px;
  margin-bottom: 8px;
}

.sub_title {
  width: 100%;
  text-align: center;
  font-weight: 400;
  font-size: 15px;
}

.line_img {
  width: 100%;
  height: 1px;
  display: block;
}
</style>
